"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@mui/material");
var _wouter = require("wouter");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _Course = _interopRequireDefault(require("./Course"));
var _CourseEdit = _interopRequireDefault(require("./CourseEdit"));
var _CourseDetail = _interopRequireDefault(require("./CourseDetail"));
var _LessonEdit = _interopRequireDefault(require("./LessonEdit"));
var _Company = _interopRequireDefault(require("./Company"));
var _CompanyAdd = _interopRequireDefault(require("./CompanyAdd"));
var _CompanyEdit = _interopRequireDefault(require("./CompanyEdit"));
var _CompanyEditAdminEmail = _interopRequireDefault(require("./CompanyEditAdminEmail"));
var _Admin = _interopRequireDefault(require("./Admin"));
var _AdminAdd = _interopRequireDefault(require("./AdminAdd"));
var _AdminEdit = _interopRequireDefault(require("./AdminEdit"));
var _AdminEditEmail = _interopRequireDefault(require("./AdminEditEmail"));
var _SideBar = _interopRequireDefault(require("./SideBar"));
var _Style = require("../../style/Style");
var _common = require("../../store/common");
var _user = require("../../store/user");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function App() {
  const [, setLocation] = (0, _wouter.useLocation)();
  const {
    setToastText,
    setToastOpen
  } = (0, _common.useCommonStore)();
  const {
    currentUser
  } = (0, _user.useUserStore)(); /*useEffect(() => {
                                 if (currentUser.isAdmin) return
                                 alert(currentUser.type)
                                 let text = ''
                                 let url = ''
                                 if (currentUser.isNone) {
                                 text = 'アクセス権限がありません。ログインしてください。'
                                 url = '/'
                                 } else if (currentUser.isCompanyAdmin) {
                                 text = 'アクセス権限がありません。'
                                 url = '/company-admin/users'
                                 } else if (currentUser.isLearner) {
                                 text = 'アクセス権限がありません。'
                                 url = '/learner/dashboard'
                                 }
                                 setToastText(text)
                                 setLocation(url)
                                 setToastOpen(true)
                                 }, []);*/
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
    container: true,
    ...stylex.props(_Style.wrapper.fill),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
      ...stylex.props(_Style.wrapper.sidebarOuter),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SideBar.default, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_wouter.Switch, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_wouter.Route, {
          path: "/course",
          component: _Course.default
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_wouter.Route, {
          path: "/course/add",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CourseEdit.default, {})
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_wouter.Route, {
          path: "/companies",
          component: _Company.default
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_wouter.Route, {
          path: "/companies/add",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CompanyAdd.default, {})
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_wouter.Route, {
          path: "/admin",
          component: _Admin.default
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_wouter.Route, {
          path: "/admin/add",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_AdminAdd.default, {})
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_wouter.Route, {
          path: "/admin/edit-email/:id",
          children: params => /*#__PURE__*/(0, _jsxRuntime.jsx)(_AdminEditEmail.default, {
            id: params.id
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_wouter.Route, {
          path: "/course/edit/:id",
          children: params => /*#__PURE__*/(0, _jsxRuntime.jsx)(_CourseEdit.default, {
            id: params.id
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_wouter.Route, {
          path: "/companies/edit/:id",
          children: params => /*#__PURE__*/(0, _jsxRuntime.jsx)(_CompanyEdit.default, {
            id: params.id
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_wouter.Route, {
          path: "/companies/edit-admin-email/:id",
          children: params => /*#__PURE__*/(0, _jsxRuntime.jsx)(_CompanyEditAdminEmail.default, {
            id: params.id
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_wouter.Route, {
          path: "/admin/edit/:id",
          children: params => /*#__PURE__*/(0, _jsxRuntime.jsx)(_AdminEdit.default, {
            id: params.id
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_wouter.Route, {
          path: "/course/detail/:id",
          children: params => /*#__PURE__*/(0, _jsxRuntime.jsx)(_CourseDetail.default, {
            id: params.id
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_wouter.Route, {
          path: "/course/:courseId/lesson/add",
          children: params => /*#__PURE__*/(0, _jsxRuntime.jsx)(_LessonEdit.default, {
            courseId: params.courseId
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_wouter.Route, {
          path: "/course/:courseId/lesson/edit/:id",
          children: params => /*#__PURE__*/(0, _jsxRuntime.jsx)(_LessonEdit.default, {
            courseId: params.courseId,
            id: params.id
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_wouter.Route, {
          path: "*",
          component: _Course.default
        })]
      })
    })]
  });
}
var _default = exports.default = App;